import React from 'react';
import Field from './Field';
import Grid from '@mui/material/Grid2';
import Box from '@mui/material/Box';
import FormLabel from '@mui/material/FormLabel';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleInfo } from '@fortawesome/free-solid-svg-icons';

export default function RadioField(props) {
  const { options, question, tooltip, xs, sm, answer, updateAnswer, primarycolor } = props;

  const handleOptionClick = (option) => {
    if (!option.disabled) {
      updateAnswer(option.value);
    }
  };

  const getOptionClassName = (option) => {
    let className = 'bq-widget-option text-only';
    if (option.value === answer) {
      className += ' active';
    }
    if (option.disabled) {
      className += ' disabled';
    }
    if (option.img) {
      className += ' image';
    }
    return className;
  };

  return (
    <Field question={question} tooltip={tooltip}>
      {options.map((option, i) => {
        const baseStyle = option.disabled
          ? { opacity: 0.5, cursor: 'not-allowed' }
          : { cursor: 'pointer' };

        if (option.value === answer && primarycolor) {  
          baseStyle.borderColor = primarycolor;
          baseStyle.backgroundColor = primarycolor;
        }

        return (
          <Grid size={{ xs, md: sm }} key={i} marginTop={1}>
            <Box
              className={getOptionClassName(option)}
              elevation={2}
              onClick={() => handleOptionClick(option)}
              style={{ minWidth: 'fit-content', ...baseStyle }}
            >
              <p>{option.label}</p>
            </Box>
          </Grid>
        );
      })}
    </Field>
  );
}
